"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactSelectStyles = void 0;
var reactSelectStyles = function (validationState) {
    return {
        control: function (base, state) { return (__assign(__assign(__assign(__assign({}, base), { outline: state.isFocused ? "-webkit-focus-ring-color auto 1px" : "none", backgroundColor: state.isFocused ? "white" : "whitesmoke", boxShadow: "none", outlineOffset: "0px", borderRadius: "4px", border: validationState === "invalid" ? "solid #d60000" : "none", fontFamily: "'Fira Sans', sans-serif" }), (state.isDisabled && {
            pointerEvents: "auto",
            cursor: "not-allowed",
            opacity: "0.3",
        })), { color: 'black' })); },
        menu: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
        input: function (base) { return (__assign(__assign({}, base), { maxWidth: "100% !important", minHeight: "3rem", fontSize: "16px", padding: "0", margin: "0", color: 'black', fontWeight: 400 })); },
        singleValue: function (base) { return (__assign(__assign({}, base), { color: 'black', fontWeight: 400 })); },
        option: function (base) { return (__assign(__assign({}, base), { color: 'black', fontWeight: 400 })); }
    };
};
exports.reactSelectStyles = reactSelectStyles;
//# sourceMappingURL=PickerStyles.js.map